export default "__VITE_ASSET__3fc071a0__"